import { ZAttrMeta } from "src/business/attribute";
import { sortedAttributes } from "src/business/attribute/sortedAttributes";
import { attrsRecordRawToInternal } from "src/business/attribute/values/attrValueRawToInternal";
import {
  ZUnsafeDataMap,
  ZUnsafeValues,
} from "src/business/attribute/ZAttrValue";
import { ZSpecification } from "src/business/specification";
import { getSpecTitle } from "src/business/specification/getSpecTitle";
import { ZValueCatalogCard } from "src/business/valueCatalog/ZValueCatalogCard";
import { recordSystemKeys } from "src/common/systemKey";
import {
  ZMfNode,
  ZMfNodeGroup,
  ZMfNodeVertNav,
} from "src/components/MForm/ZMfNode";
import { ZSidLabel } from "src/types";

export const makeValueCatalogRecInfo = (
  spec: ZSpecification,
  srcData?: ZValueCatalogCard,
) => {
  const parts: ZMfNodeGroup[] = [];
  const data: ZUnsafeDataMap = {};

  if (srcData) {
    // TODO: Было бы неплохо выделить общие части кода с src\pages\catalogs\CatalogRecordForm\makeRecordForm.ts
    const { id, displayId } = srcData;
    parts[0] = createGroup(recordSystemKeys.first, "Идентификаторы", [
      attrMeta({
        name: "displayId",
        title: "Display Id",
        type: { name: "number", precision: 0 },
      }),
      attrMeta({
        name: "id",
        title: "UUID",
        type: { name: "string" },
        edit: { colSpan: 2 },
      }),
    ]);
    data[recordSystemKeys.first] = { id, displayId };
  }

  const attributes = sortedAttributes(spec.definition?.attributes);
  parts.push(
    createGroup(
      spec.name,
      getSpecTitle(spec),
      attributes.map((attr) => ({ type: "attr", attr })),
    ),
  );

  const srcDataPart = srcData?.data?.[spec.name];
  if (srcDataPart) {
    const dataPart: ZUnsafeValues = attrsRecordRawToInternal(
      srcDataPart,
      attributes,
    );
    data[spec.name] = dataPart;
  }

  if (srcData) {
    const { createdBy, createdAt, updatedBy, updatedAt } = srcData;
    const lastPart = createGroup(recordSystemKeys.last, "Историчность", [
      // TODO: вынести в общую часть SysData
      createPersLink("createdBy", "Автор создания", createdBy),
      attrMeta({
        name: "createdAt",
        title: "Дата создания",
        type: { name: "dateTime" },
      }),
      createPersLink("updatedBy", "Автор последнего изменения", updatedBy),
      attrMeta({
        name: "updatedAt",
        title: "Дата последнего изменения",
        type: { name: "dateTime" },
      }),
    ]);
    parts.push(lastPart);
    data[recordSystemKeys.last] = {
      createdBy,
      createdAt,
      updatedBy,
      updatedAt,
    };
  }

  const meta: ZMfNodeVertNav = {
    type: "vertNav",
    useNavBar: true,
    nodes: parts,
  };
  return { meta, data };
};

const createGroup = (
  name: string,
  title: string,
  nodes: ZMfNode[],
): ZMfNodeGroup => ({
  type: "group",
  name,
  title,
  content: {
    node: {
      type: "grid",
      nodes,
    },
  },
});

const attrMeta = (
  attr: Omit<ZAttrMeta, "displayId" | "uid">,
  enabled?: boolean,
): ZMfNode => ({
  type: "attr",
  attr: {
    uid: "",
    displayId: 0,
    ...attr,
  },
  disableIf: enabled ? undefined : { type: "true" },
});

const createPersLink = (
  name: string,
  title: string,
  value?: ZSidLabel | null,
) =>
  attrMeta({
    name,
    title,
    type: { name: "strOption" },
    edit: {
      component: {
        type: "Select",
        options: {
          type: "inline",
          list: value ? [value] : [],
        },
      },
    },
  });
